import { isNumber, isObject, isString, isUndefinedOrNull } from "@omnia/shared/utils/utils";
import { ApiResourceAccessRestrictions } from "./api";
import { ResourceOwner, ResourceWithMetadata } from "@omnia/shared/resources/types";
import { getOwnerId } from "@omnia/shared/resources/typeguards";


export type UserId = string

export type ResourceAccessRestrictions = ReturnType<typeof convertResourceAccessRestrictionsFromApi>

export function convertResourceAccessRestrictionsFromApi(api: ApiResourceAccessRestrictions) {

    const owners = api?.Owners
        ? api.Owners.map(o => ({
            userId: String(o.UserId) as UserId
        }))
        : undefined

    return {

        owners,

        isUnrestricted: owners === undefined,

        canAccessResourceOwnedBy(userId: UserId) {

            if (this.isUnrestricted) {
                return true
            }

            return this.owners.some(o => o.userId === userId)

        }

    } as const


}

export function isResourceAccessible(
    { accessRestrictions: ar }  : {  accessRestrictions: ResourceAccessRestrictions },
    arg: number | string | ResourceOwner | ResourceWithMetadata
) {

    if (ar?.isUnrestricted ?? true) {
        return true
    }

    const ownerId = getOwnerId(arg)

    const r = ar.canAccessResourceOwnedBy(ownerId)

    return r

}
